module.exports = __webpack_public_path__ + "img/DE00013.9bf69875.png";